import { createContext } from 'react';

export const EnvProviderContext = createContext<{ envConfig: Record<string, string> }>({ envConfig: {} });

export function EnvProvider({ children, ...props }) {
  const { envConfig } = props;
  const value = {
    envConfig: envConfig ? envConfig : null,
  };
  return (
    <EnvProviderContext.Provider value={value} {...props}>
      {children}
    </EnvProviderContext.Provider>
  );
}
